//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpSpinnerLoader',
  props: {
    size: { type: String, default: 'default' },
  },
};
